/**
 * Formats a date string to DD-MMM-YYYY format (e.g. 05-JAN-2025)
 * Used consistently across the entire application
 */
export const formatDate = (value) => {
  if (!value) return "-----";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "-----";
  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .split(" ")
    .join("-")
    .toUpperCase();
};

/**
 * Returns true if the given date is within the next N months from today
 */
export const isWithinMonths = (dateStr, months = 6) => {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return false;
  const future = new Date();
  future.setMonth(future.getMonth() + months);
  return date >= new Date() && date <= future;
};
